import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './Offerings.css';

const Offerings = () => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      {
        threshold: window.innerWidth <= 768 ? 0.05 : 0.1,
        rootMargin: '30px'
      }
    );

    const section = document.getElementById('offerings');
    if (section) {
      observer.observe(section);
    }

    return () => {
      if (section) {
        observer.unobserve(section);
      }
    };
  }, []);

  const offerings = [
    {
      title: t('offerings.services.ai.title'),
      description: t('offerings.services.ai.description'),
      icon: '🤖',
      color: 'blue'
    },
    {
      title: t('offerings.services.web.title'),
      description: t('offerings.services.web.description'),
      icon: '💻',
      color: 'violet'
    },
    {
      title: t('offerings.services.crm.title'),
      description: t('offerings.services.crm.description'),
      icon: '📊',
      color: 'green'
    },
    {
      title: t('offerings.services.vfx.title'),
      description: t('offerings.services.vfx.description'),
      icon: '🎮',
      color: 'teal'
    }
  ];

  return (
    <section id="offerings" className="offerings section">
      <div className="container">
        <div className={`offerings-content ${isVisible ? 'visible' : ''}`}>
          <h2 className="offerings-title fade-in-up">
            {t('offerings.title')}
          </h2>
          <p className="offerings-subtitle fade-in-up">
            {t('offerings.subtitle')}
          </p>

          <div className="offerings-grid">
            {offerings.map((offering, index) => (
              <div
                key={index}
                className={`offering-card slide-in-left ${isVisible ? 'visible' : ''} ${offering.color}`}
                style={{ animationDelay: `${0.2 + index * 0.1}s` }}
              >
                <div className="card-icon">
                  <span className="icon-emoji">{offering.icon}</span>
                </div>
                <h3 className="card-title">{offering.title}</h3>
                <p className="card-description">{offering.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Offerings;